module.exports = __webpack_public_path__ + "img/cintes-KRAFT.dcfc31c7.jpg";